export default __webpack_public_path__ + "static/media/nature_dark_female.fb6cc408.png";